import React from "react";

import { MdMenuBook } from "react-icons/md";
import { GiChickenOven, GiChefToque } from "react-icons/gi";

const Feature = ({ feature, icon }) => {
  return (
    <div className="feature-container">
      <div className="feature-container-icon">
        {icon === "menu" ? (
          <MdMenuBook />
        ) : icon === "produce" ? (
          <GiChickenOven />
        ) : (
          <GiChefToque />
        )}
      </div>
      <h3 className="feature-title">{feature.title}</h3>
      <p className="feature-content">{feature.content}</p>
    </div>
  );
};

export default Feature;
